import { render, staticRenderFns } from "./goalInfo.vue?vue&type=template&id=3201e185&scoped=true"
import script from "./goalInfo.vue?vue&type=script&lang=js"
export * from "./goalInfo.vue?vue&type=script&lang=js"
import style0 from "./goalInfo.vue?vue&type=style&index=0&id=3201e185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201e185",
  null
  
)

export default component.exports